import { useEffect } from 'react';
import useIsMounted from '../hooks/useIsMounted';

export default function PreventNavigation() {
  const isMounted = useIsMounted();

  useEffect(() => {
    if (isMounted.current) window.onbeforeunload = () => true;
    return () => {
      window.onbeforeunload = () => undefined;
    };
  }, []);

  return null;
}
